import { plainToClass } from "class-transformer";
import { Token, TokenSSO } from "src/containers/authentication/models/token";

class TokenMapper {
    static fromTokenSSO(tokenSSO: TokenSSO) {
        return plainToClass(Token, {
            value: tokenSSO.accessToken,
            type: "Bearer",
            expiresIn: 900000,
            applicationUser: tokenSSO.applicationUser,
        });
    }
}

export { TokenMapper };
